export const ENERGY_RATING_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  DEFAULT: 'default',
} as const;
export type EnergyRatingSize = ValueOf<typeof ENERGY_RATING_SIZE>;
